import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, setToken } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refresh = useCallback(() => api.get("/auth/me").then((r) => { setUser(r.data); return r.data; }).catch(() => { setUser(false); return false; }), []);
  useEffect(() => { refresh(); }, [refresh]);

  const finish = (data) => { setToken(data.access_token); setUser(data.user); return data.user; };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.requires_2fa) return { requires_2fa: true, pending_token: data.pending_token };
    return finish(data);
  };

  const verify2fa = async (pending_token, code) => finish((await api.post("/auth/2fa/verify", { pending_token, code })).data);

  const changePassword = async (current_password, new_password) => finish((await api.post("/auth/password", { current_password, new_password })).data);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    setToken(null);
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, login, verify2fa, changePassword, logout, refresh }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
